import { Kits } from 'utils/gloo-types';
import { discoverItemCardForKit } from 'utils/discover';
import DiscoverCardPreview from '../DiscoverCardPreview';

interface KitPreviewCardProps {
  kitPreview: Partial<Kits>;
}

function KitPreviewCard({ kitPreview }: KitPreviewCardProps) {
  return (
    <DiscoverCardPreview
      itemCard={discoverItemCardForKit(kitPreview)}
      onClick={() => {
        // noop
      }}
      className="w-full px-2 pb-8"
    />
  );
}

export default KitPreviewCard;
